import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektDaten: FC<{}> = () => {
	const { application, setApplicationProperty, printMode, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} printMode={printMode}/>
		</>
	);
};

export default ProjektDaten;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Zusammenfassung_Ueberblick_Titel, label: 'Antragstitel', disabled: true }],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				{ ...P.Zusammenfassung_Ueberblick_Laufzeit_Von, disabled: true },
				{ ...P.Zusammenfassung_Ueberblick_Laufzeit_Bis, disabled: true },
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				{ ...P.Zusammenfassung_Ueberblick_Funktion },
				{ ...P.Zusammenfassung_Ueberblick_Vertretername },
			],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [
				{ ...P.Zusammenfassung_Ueberblick_Unterschriftsberechtigte_Person, label: 'Unterschriftsberechtigte Person', },
			],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};

export const getFormStrucProjektDaten = () => {
	return concat(formStruc());
};
